import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { api } from "../../redux/apis/api";
import { FormDropDown } from "../../components/form/dropdown";
import { FormDateField } from "../../components/form/date";
import { FormDocumentField } from "../../components/form/document-field";
import { useState } from "react";
import { useEffect } from "react";

const EditPayment = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [customerlist, setcustomerlist] = useState([]);
  const [orderslist, setorderslist] = useState([]);

  const initialValues = {
    id: data?.id ?? null,
    customer_id: data?.customer_id ?? null,
    order_id: data?.order_id ?? null,
    amount_paid: data?.amount_paid ?? "",
    payment_mode: data?.payment_mode ?? "",
    payment_date: data?.payment_date ?? null,
    payment_photo_url: data?.payment_photo_url ?? "",
    status: data?.status ?? "",
    cheque_date: data?.cheque_date ?? null,
    transaction_number: data?.transaction_number ?? "",
    refund_mode: data?.refund_mode ?? null,
    refund_photo_url: data?.refund_photo_url ?? null,
    refund_upi: data?.refund_upi ?? null,
    refund_account_number: data?.refund_account_number ?? null,
    refund_bank: data?.refund_bank ?? null,
    refund_ifsc: data?.refund_ifsc ?? null,
    refund_transaction_number: data?.refund_transaction_number ?? null,
    billing_type: data?.billing_type ?? null,
  };

  const validationSchema = Yup.object().shape({
    amount_paid: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/payment/edit`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/payment/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const paymentModaList = [
    {
      label: "Online",
      value: "online",
    },
    {
      label: "Cash",
      value: "cash",
    },
    {
      label: "Cheque",
      value: "cheque",
    },
  ];

  const billingTypeOptions = [
    {
      label: "Taxed",
      value: "taxed",
    },
    {
      label: "Cash",
      value: "cash",
    },
  ];

  const statusList = [
    {
      label: "Received",
      value: "received",
    },
    {
      label: "Not received",
      value: "not_received",
    },
    {
      label: "Sent for clearing",
      value: "sent_for_clearing",
    },
    {
      label: "Cleared",
      value: "cleared",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
    {
      label: "Received cheque",
      value: "received_cheque",
    },
    {
      label: "Refunded",
      value: "refunded",
    },
  ];

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/payment/view`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchCustomerDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setcustomerlist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchorderDropDownData = () => {
    api
      .get(`/payment/order-drodown`)
      .then((res) => {
        let newArr = res?.data?.data?.orders?.map((ele) => ({
          label: ele.id,
          value: ele.id,
        }));
        setorderslist(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchData();
    fetchCustomerDropDownData();
    fetchorderDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Payment - Edit
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/payment/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormDropDown
                    name="customer_id"
                    label="customer"
                    options={customerlist}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="order_id"
                    label="order"
                    options={orderslist}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"amount_paid"}
                    label={"amount paid"}
                    placeholder={`Enter amount paid`}
                  />
                </div>

                <div className="my-4">
                  <FormDropDown
                    name="payment_mode"
                    label="payment mode"
                    options={paymentModaList}
                  />
                </div>
                <div className="my-4">
                  <FormDateField name={"payment_date"} label={"payment date"} />
                </div>
                <div className="my-4">
                  <FormDocumentField
                    name={"payment_photo_url"}
                    label={"payment photo"}
                  />
                </div>

                <div className="my-4">
                  <FormDropDown
                    name="billing_type"
                    label="Billing Type"
                    options={billingTypeOptions}
                  />
                </div>

                {values?.payment_mode === "cheque" && (
                  <div className="my-4">
                    <FormDateField name={"cheque_date"} label={"cheque date"} />
                  </div>
                )}

                {(values?.payment_mode === "online" ||
                  values?.payment_mode === "cheque") && (
                  <div className="my-4">
                    <FormTextField
                      name={"transaction_number"}
                      label={"transaction number"}
                      placeholder={`Enter transaction number`}
                    />
                  </div>
                )}
                <div className="my-4">
                  <FormDropDown
                    name="status"
                    label="status"
                    options={statusList}
                    menuPlacement="top"
                  />
                </div>

                {(values?.status === "rejected" ||
                  values?.status === "refunded") && (
                  <>
                    <div className="my-4">
                      <FormDropDown
                        name="refund_mode"
                        label="refund mode"
                        options={paymentModaList}
                      />
                    </div>
                    <div className="my-4">
                      <FormDocumentField
                        name={"refund_photo_url"}
                        label={"refund photo"}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"refund_upi"}
                        label={"refund upi"}
                        placeholder={`Enter refund upi`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"refund_account_number"}
                        label={"refund account number"}
                        placeholder={`Enter refund account number`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"refund_bank"}
                        label={"refund bank"}
                        placeholder={`Enter refund bank`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"refund_ifsc"}
                        label={"refund ifsc"}
                        placeholder={`Enter refund ifsc`}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"refund_transaction_number"}
                        label={"refund transaction number"}
                        placeholder={`Enter refund transaction number`}
                      />
                    </div>
                  </>
                )}
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditPayment;
